import React from "react"

const LifestyleSelected = () => (
    <div className="experiences__selected">
        <div className="container">
            <div className="has-text-white experiences__selected--columns">
                <div className="info px-0">
                    <p className="pb-5">
                        We spark new ideas, whether it be health and wellness,
                        consumer entertainment, aspects of consumer lifestyle.
                        We explore a multitude of trends that will provide
                        insight and inspiration for your next big idea.
                    </p>
                </div>
            </div>
        </div>
    </div>
)

export default LifestyleSelected
